import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";
import { Link, useLocation } from "react-router-dom";
import {
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
  AiOutlineMail
} from "react-icons/ai";

import { CgFileDocument } from "react-icons/cg";
import styled from "styled-components";

const StyledNavbar = styled(Navbar)`
  .nav-link {
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  
  .navbar-brand {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
  }
  
  .nav-icon {
    margin-bottom: 2px;
    font-size: 1.2rem;
  }
  
  .menu-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
`;

function NavBar() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [navColour, setNavColour] = useState(false);
  const location = useLocation();

  function scrollHandler() {
    if (window.scrollY >= 20) {
      setNavColour(true);
    } else {
      setNavColour(false);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", scrollHandler);
    
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <StyledNavbar
      expanded={isExpanded}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img src={logo} className="img-fluid logo" alt="brand" />
          <span>Mehdi Chafai</span>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            setIsExpanded(isExpanded ? false : "expanded");
          }}
        >
          <div className="menu-icon">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link 
                as={Link} 
                to="/" 
                onClick={() => setIsExpanded(false)}
                className={isActive("/") ? "active" : ""}
              >
                <AiOutlineHome className="nav-icon" /> Accueil
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/about"
                onClick={() => setIsExpanded(false)}
                className={isActive("/about") ? "active" : ""}
              >
                <AiOutlineUser className="nav-icon" /> Moi
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/project"
                onClick={() => setIsExpanded(false)}
                className={isActive("/project") ? "active" : ""}
              >
                <AiOutlineFundProjectionScreen className="nav-icon" /> Projets
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/resume"
                onClick={() => setIsExpanded(false)}
                className={isActive("/resume") ? "active" : ""}
              >
                <CgFileDocument className="nav-icon" /> CV
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/contact"
                onClick={() => setIsExpanded(false)}
                className={isActive("/contact") ? "active" : ""}
              >
                <AiOutlineMail className="nav-icon" /> Contact
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </StyledNavbar>
  );
}

export default NavBar;